import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';

import {cx} from '@emotion/css';
import LayoutSection from '../../DesignSystem/Layout/LayoutSection/LayoutSection';
import {LayoutBackground} from '../../DesignSystem/Layout/LayoutSection/LayoutSection.types';
import HomepageCheckpoints from '../Checkpoints/Checkpoints';
import GetStartedButton from '../../DesignSystem/Buttons/GetStarted/GetStarted';
import TrustPilotWidget from '../../DesignSystem/TrustpilotWidget/TrustpilotWidget';
import {TrustpilotWidgetVariant} from '../../DesignSystem/TrustpilotWidget/trustpilotWidgetVariantConfig';
import Headers, {HeaderType} from '../../DesignSystem/Text/Headers/Headers';
import Paragraph, {FontSize, FontWeight} from '../../DesignSystem/Text/Paragraph/Paragraph';
import {Alignment} from '../../../types';
import heroImage from '../../../images/Hero/homepageHero.png';

import styles from './Hero.styles';

function Hero(): ReactElement {
  const {formatMessage} = useIntl();
  return (
    <LayoutSection innerClassName={cx(styles.homepageHero)} type={LayoutBackground.GRAY}>
      <div className={cx(styles.content)}>
        <Headers headerType={HeaderType.H1} alignment={Alignment.LEFT}>
          <FormattedMessage id="homepage.hero.title" />
        </Headers>
        <Paragraph
          className={cx(styles.description)}
          alignment={Alignment.LEFT}
          fontSize={FontSize.EXTRA_LARGE}
          fontWeight={FontWeight.SEMIBOLD}
        >
          <FormattedMessage id="homepage.hero.description" />
        </Paragraph>
        <HomepageCheckpoints />
        <GetStartedButton />
      </div>
      <div className={cx(styles.supportingInfo)}>
        <img className={cx(styles.image)} alt={formatMessage({id: 'homepage.hero.imageAlt'})} src={heroImage} />
        <div className={cx(styles.trustPilot)}>
          <TrustPilotWidget variant={TrustpilotWidgetVariant.MINI} />
        </div>
      </div>
    </LayoutSection>
  );
}

export default Hero;
